/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.name = exports.Loading = void 0;

var react_1 = __importDefault(require("react"));

var StyleUtils_1 = __importDefault(require("./utils/StyleUtils"));

var name = 'Loading';
exports.name = name;

var Loading = function Loading(_ref) {
  var Frame = _ref.Frame,
      LoadingIndicator = _ref.LoadingIndicator,
      styles = _ref.styles;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      _classCallCheck(this, _class);

      return _super.call(this, props);
    }

    _createClass(_class, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            backgroundColor = _this$props.backgroundColor,
            classes = _this$props.classes,
            color = _this$props.color,
            height = _this$props.height,
            width = _this$props.width;
        return react_1.default.createElement(Frame, {
          className: ['Loading__container', classes === null || classes === void 0 ? void 0 : classes.container],
          style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.container), {
            height: height,
            width: width
          })
        }, react_1.default.createElement(LoadingIndicator, {
          className: classes === null || classes === void 0 ? void 0 : classes.indicator,
          style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.indicator), {
            borderColor: backgroundColor,
            borderTopColor: color
          })
        }));
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.Loading = Loading;

var style = function style(theme) {
  var _a, _b, _c;

  return {
    container: Object.assign({
      left: '50%',
      height: 50,
      position: 'absolute',
      top: '50%',
      '@mobile': {
        transform: [{
          translateX: -25
        }, {
          translateY: -25
        }]
      },
      width: 50,
      '@web': {
        transform: 'translate(-50%, -50%)'
      }
    }, (_a = theme === null || theme === void 0 ? void 0 : theme.Loading) === null || _a === void 0 ? void 0 : _a.container),
    indicator: Object.assign(Object.assign(Object.assign({}, StyleUtils_1.default.border('5px solid rgba(0,0,0,.1)')), {
      animation: 'spin 0.7s linear infinite',
      background: 'transparent',
      borderTopColor: (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.accent,
      borderRadius: 50,
      boxSizing: 'border-box',
      width: '100%',
      height: '100%'
    }), (_c = theme === null || theme === void 0 ? void 0 : theme.Loading) === null || _c === void 0 ? void 0 : _c.indicator),
    '@keyframes spin': {
      from: {
        transform: 'rotate(0deg)'
      },
      to: {
        transform: 'rotate(360deg)'
      }
    }
  };
};

exports.style = style;